export const formatDate = (isoDateString: any) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    const date = new Date(isoDateString);
    const parts = date.toLocaleDateString('en-US', options).split(/,?\s+/)
    const day = parts[1]
    const month = parts[0]
    const year = parts[2]
    return `${day} ${month} ${year}`;
}